import { Authenticator, ThemeProvider } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { Grid } from "@mui/material";
import { LoadingScreen } from "../components/Loading/LoadingScreen";
import { amplifyCustomTheme } from "../components/Login/amplifyTheme";
import { AuthenticatorComps } from "../components/Login/AuthenticatorComps";
import LoginInfo from "../components/Login/LoginInfo";
import { useAuthContext } from "../hooks/Auth";
import { usePresignErrorToast } from "../hooks/usePresignErrorToast";

function LoginPage() {
  const { isLoadingLogin } = useAuthContext();
  // Hook personalizado para manejar el error proveniente del Lambda PreSign
  usePresignErrorToast();

  if (isLoadingLogin) {
    return <LoadingScreen />;
  }

  return (
    <Grid container sx={{ minHeight: "100vh" }}>
      {/* Recuadro informativo izquierdo */}
      <LoginInfo />

      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: 2,
        }}
      >
        {/* ThemeProvider cambia el estilo del autenticador */}
        <ThemeProvider theme={amplifyCustomTheme}>
          {/* Componente de Amplify UI para realizar autenticación con Cognito */}
          <Authenticator
            /* key={authenticatorKey} */
            components={AuthenticatorComps}
            hideSignUp
            socialProviders={["google"]}
            initialState="signIn"
          ></Authenticator>
        </ThemeProvider>
      </Grid>
    </Grid>
  );
}

export default LoginPage;
